__turbopack_context__.v({
  "hide-arrows": "Ean-module-scss-module__k2AyAa__hide-arrows",
});
